import { Component, OnInit,Output,EventEmitter } from '@angular/core';
import { NewsItem } from '../../../models/NewsItem';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { GlobalService } from '../../../services/global';
import { User } from '../../../models/User';
import { InfoCenterFile } from '../../../models/InfoCenterFile';
import { HttpService } from '../../../services/HttpService';
import { FilterObject } from '../../../models/FilterObject';
@Component({
  selector: 'app-news-item-popup',
  templateUrl: './news-item.component.html',
  styleUrls: ['./news-item.component.css']
})
export class NewsItemModalComponent implements OnInit {
  NewNewsItem: NewsItem;
  CurUser: User;
  CurrentFile: FormData;
  InfoCenterFiles: InfoCenterFile[];
  FilterList: FilterObject[];
  @Output("disableActionButton") disableActionButton: EventEmitter<string> = new EventEmitter<string>();  
  @Output("enableButtons") enableButtons: EventEmitter<string> = new EventEmitter<string>();

  faPaperclip = faPaperclip;
  constructor(private global:GlobalService, private http:HttpService) { }


  ngOnInit(): void {
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      this.FilterList = [];
      this.http.GetAllInfoCenterFiles(this.FilterList,this.CurUser.UserId.toString()).then(y => {
        if (y.StatusCode == "200") {
          this.InfoCenterFiles = y.Content;
          this.InfoCenterFiles = this.InfoCenterFiles.filter(x => x.Type == 'upload');
        }
      });

    });
  }

  InputValidate() {
    if (this.NewNewsItem.Title.length > 0 && this.NewNewsItem.Description.length > 0 && (this.NewNewsItem.Link.length > 0 || this.NewNewsItem.InfoCenterFileID.length > 0)) {
      this.enableButtons.emit("");
    }
    else {
      this.disableActionButton.emit("");
    }
  }

  Validate():boolean {
    if (this.NewNewsItem.Title.length > 0 && this.NewNewsItem.Description.length > 0 && ((this.NewNewsItem.Type == 'directlink' && this.NewNewsItem.Link.length > 0) || (this.NewNewsItem.Type == 'infocenterfile' && this.NewNewsItem.InfoCenterFileID.length > 0))) {
      return true;
    }
    else {
      return false;
    }
  }

  SetNewsItem(item: NewsItem) {
    this.disableActionButton.emit("");
    this.NewNewsItem = item;

    if (this.NewNewsItem.NewsItemID > 0) {
      this.enableButtons.emit("");
    }
  }

  GetNewsItem(): NewsItem {
    if (this.NewNewsItem.NewsItemID == 0) {
      this.NewNewsItem.CreatedBy = this.CurUser.UserId.toString();
    }
    this.NewNewsItem.UpdatedBy = this.CurUser.UserId.toString();
    if (this.NewNewsItem.Type == 'directlink') {
      this.NewNewsItem.InfoCenterFile = null;
      this.NewNewsItem.InfoCenterFileID = '';
    } else if (this.NewNewsItem.Type == 'infocenterfile') {
      this.NewNewsItem.Link = '';      
    }
    return this.NewNewsItem;
  }


  onFileSelected(event) {
    let file = <File>event.target.files[0];
    debugger;

    if (file) {
      this.NewNewsItem.ImagePath = file.name;
      this.CurrentFile = new FormData();
      this.CurrentFile.append('file', file, file.name);
      this.NewNewsItem.ImageFile = file;
    }
  }

}
